import { useMemo, useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import { PageMode } from '@gp/enums/common';

// 查看详情、编辑 弹窗配置
export interface IModalConfig<IModalData> {
  // 查看弹窗title
  reviewModalTitle?: string;
  // 编辑弹窗title
  editModalTitle?: string;
  // 弹窗数据的默认值
  defaultModalData?: IModalData;
}

/**
 * 查看详情、编辑 弹窗，封装弹窗visible、弹窗mode（查看详情模式、编辑模式）、更新弹窗需要的data
 */
export default function useReviewOrEditModal<IModalData = {}>(
  config: IModalConfig<IModalData>,
) {
  const {
    reviewModalTitle = 'Review',
    editModalTitle = 'Edit',
    defaultModalData = {} as IModalData,
  } = config || {};

  // 弹窗模式，定义看PageMode枚举
  const [modalMode, setModalMode] = useState<PageMode>(PageMode.Review);
  // 弹窗title
  const modalTitle = useMemo<string>(() => {
    return modalMode === PageMode.Edit ? editModalTitle : reviewModalTitle;
  }, [modalMode, reviewModalTitle, editModalTitle]);
  // 弹窗visible
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  // 弹窗需要的数据
  const [modalData, setModalData] = useState<IModalData>(defaultModalData);

  // 打开弹窗
  const openModal = useMemoizedFn((flag: PageMode, payload: IModalData) => {
    if (![PageMode.Review, PageMode.Edit].includes(flag)) return;
    const modalDataTemp: IModalData = {
      ...modalData,
      ...payload,
    };
    setModalMode(flag);
    setModalData(modalDataTemp);
    setModalVisible(true);
  });

  // 关闭弹窗
  const closeModal = useMemoizedFn(() => {
    // setModalMode(PageMode.Review);
    // setModalData(defaultModalData);
    setModalVisible(false);
  });

  return {
    modalMode,
    modalTitle,
    modalVisible,
    modalData,
    setModalData,
    openModal,
    closeModal,
  };
}
